import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=5a0da743&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"
import style0 from "./Friends.vue?vue&type=style&index=0&id=5a0da743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0da743",
  null
  
)

export default component.exports